// core
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OpenModule } from '@campfire-nx/open';
import { MaterialModule } from '@campfire-nx/material';

// components
import { OverviewLandingComponent } from './overview-landing/overview-landing.component';

// modules
import { OverviewRoutingModule } from './overview-routing.module';
import { ComponentsModule } from '@open-portal-app/components/components.module';

@NgModule({
  declarations: [
    OverviewLandingComponent
  ],
  imports: [
    CommonModule,
    OpenModule,
    MaterialModule,
    OverviewRoutingModule,
    ComponentsModule
  ]
})
export class OverviewModule { }
